import { inject } from "@angular/core";
import { NavigationItem } from "@claas/claas-ui-components/navigation/navigation";
import { patchState, signalStore, withMethods, withState } from "@ngrx/signals";
import { rxMethod } from "@ngrx/signals/rxjs-interop";
import { pipe, switchMap, tap } from "rxjs";
import { CoreMediaNavigationClient } from "./coremedia-navigation.client";
import { environment } from "../../../../../environments/environment";

interface FooterLegalLinksState {
  items: NavigationItem[];
  status: "idle" | "loading" | "ready" | "error";
  error: unknown;
}

const initialState: FooterLegalLinksState = {
  items: [],
  status: "idle",
  error: null,
};

export const footerLegalLinksStore = signalStore(
  { providedIn: "root" },
  withState(initialState),
  withMethods((store, client = inject(CoreMediaNavigationClient)) => ({
    load: rxMethod<void>(
      pipe(
        tap(() => patchState(store, { status: "loading", error: null })),
        switchMap(() =>
          client
            .loadLocalizedMenuTree(
              environment.footerLegalLinks.channelId,
              environment.footerLegalLinks.siteName,
            )
            .pipe(
              tap({
                next: (items) =>
                  patchState(store, { items, status: "ready", error: null }),
                error: (error) => patchState(store, { status: "error", error }),
              }),
            ),
        ),
      ),
    ),
  })),
);
